<template>
  <footer class="dark-footer">
    <div class="footer-center">
      <dl class="module-item">
        <dt>新手指南</dt>
        <dd>
          <a href="javascript:void(0)" class="link" @click="$router.push('/companyLogin')">注册登录</a>
          <a href="/Help/newAgreement-fwfxw.html" class="link">服务商行为规则</a>
          <a href="/Help/helpCenter_01.html" class="link">帮助中心</a>
        </dd>
      </dl>
      <dl class="module-item">
        <dt>需求中心</dt>
        <dd>
          <a href="/Help/helpCenter_03.html" class="link">工单发布规则</a>
        </dd>
      </dl>
      <dl class="module-item">
        <dt>服务中心</dt>
        <dd>
          <a href="javascript:void(0)" class="link" @click="register(1)">申请成为工程师</a>
          <a href="javascript:void(0)" class="link" @click="register(2)">申请成为服务站</a>
        </dd>
      </dl>
      <dl class="module-item">
        <dt>交易保障</dt>
        <dd>
          <a href="/Help/helpCenter_13.html" class="link">服务保障</a>
          <a href="/Help/helpCenter_16.html" class="link">意见反馈</a>
        </dd>
      </dl>
      <div class="contact-module">
        <div class="hd">联系我们</div>
        <div class="service-tel">24小时客服电话：<i class="tel">021-60956592</i></div>
        <div class="service-tel" style="margin-bottom: 10px;">24小时业务联系电话：<i class="tel">16621540669</i></div>
        <div class="qrcode-group">
          <div class="qrcode-box">
            <img class="qrcode" src="../assets/fixedRight/supaiweixin_ercode.jpg" alt="">
            <span class="name">微信公众号</span>
          </div>
          <div class="qrcode-box">
            <img class="qrcode" src="../assets/fixedRight/supaiapp_ercode.png" alt="">
            <span class="name">工业速派APP</span>
          </div>
        </div>
      </div>
    </div>
    <gk-footer></gk-footer>
  </footer>
</template>
<script>
import gkFooter from '@/components/footer.vue'
import { mapState } from 'vuex'
export default {
  components:{
    gkFooter
  },
  data(){
    return{
      
    }
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo,
    })
  },
  methods: {
    register(type){
      if(type==1){
        this.$alert('请下载APP注册工程师');
      }else{
        if(this.userInfo && this.userInfo.LoginAccountId){
          
          if(this.userInfo.LoginAccountType==1){
            this.$confirm('您不是企业账号', '提示', {
              confirmButtonText: '企业登录',
              cancelButtonText: '企业注册',
              type: 'warning'
            }).then(() => {
              this.$router.push('/companyLogin');
            }).catch((err) => {
              if(err=='cancel'){
                return;
              }
              this.$router.push('/serviceRegister?type=2');        
            });
          }else{
            if(this.userInfo.IsServiceSite){
              this.$alert('您已经是注册服务站');
            }else{
              this.$router.push('/center/serviceSiteInfo');
            }
          }
        }else{
          this.$router.push('/serviceRegister?type=2');
        }
      }
    }
  },
}
</script>
<style lang="scss">
.dark-footer{
  background-color: #363636;
  overflow: hidden;
  width: 100%;
  .footer-center{
    width: 1200px;
    padding: 50px 0 0px;
    margin: 0 auto;
    overflow: hidden;
    padding-left: 80px;
  }
  .module-item{
    float: left;
    width: 170px;
    margin-right: 30px;
    dt{
      font-size: 18px;
      color: #fff;
      line-height: 32px;
      margin-bottom: 20px;
    }
    .link{
      display: block;
      font-size: 14px;
      color: #999;
      line-height: 24px;
      margin-bottom: 10px;
      &:hover{
        color: #fff;
      }
    }
  }
  .contact-module{
    float: right;
    .hd{
      font-size: 18px;
      color: #fff;
      line-height: 32px;
      margin-bottom: 20px;
    }
    .service-tel{
      font-size: 18px;
      color: #fff;
      line-height: 32px;
      //margin-bottom: 20px;
      .tel{
        color: #faea4b;
        font-size: 20px;
      }
    }
    .qrcode-group{
      overflow: hidden;
    }
    .qrcode-box{
      float: left;
      margin-right: 30px;
      .qrcode{
        width: 110px;
        height: 110px;
        display: block;
      }
      .name{
        color: #fff;
        font-size: 14px;
        line-height: 24px;
        display: block;
        text-align: center;
        margin-top: 3px;
      }
    }
  }
}
</style>